var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadingSpinner',{attrs:{"isLoading":_vm.isLoading}},[(_vm.renderWorkflowJobComponent && !_vm.isLoading)?_c(_vm.workflowJob.jobComponentName,{tag:"component",attrs:{"errorModel":_vm.workflowJob.errorModel}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }